import script from "./RejectReasonModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RejectReasonModal.vue?vue&type=script&setup=true&lang=js"

import "./RejectReasonModal.vue?vue&type=style&index=0&id=165c3f46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165c3f46"]])

export default __exports__